"use client";

import { createContext, type FC, type PropsWithChildren, useContext, useMemo } from "react";

type PageAuthState = {
  // Presentation hint only — whether to render the logged-in variant. Never authorization.
  isLoggedIn: boolean;
};

const PageAuthContext = createContext<PageAuthState | null>(null);

type PageAuthProviderProps = PropsWithChildren<{
  isLoggedIn: boolean;
}>;

export const PageAuthProvider: FC<PageAuthProviderProps> = ({ isLoggedIn, children }) => {
  const value = useMemo<PageAuthState>(() => ({ isLoggedIn }), [isLoggedIn]);

  return <PageAuthContext.Provider value={value}>{children}</PageAuthContext.Provider>;
};

export const useIsLoggedIn = (): boolean => {
  return useContext(PageAuthContext)?.isLoggedIn ?? false;
};
